exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".collapse-title{-ms-flex:1 0 90%;flex:1 0 90%;-ms-flex-order:1;order:1;color:#039ccf;border:none;height:auto;line-height:22px;padding-top:5px;padding-bottom:10px;font-size:large;font-weight:700}::v-deep .el-collapse{border:none}.collapse-content{font-size:medium;color:gray}.adaptercard{width:33%;text-align:center;vertical-align:bottom;-ms-flex-align:baseline;align-items:baseline}.adaptercard img{max-width:100%;max-height:180px;margin:0}.adaptertitle{bottom:0;vertical-align:bottom;margin-top:20px}.specialCard{width:80%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2041624d","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/qanda.vue
// module id = 143
// module chunks = 0